import React from 'react'
import { CruiseContentSections } from 'constants/cruise'
import FormatCurrency from 'components/Common/FormatCurrency'
import TextButton from 'components/Luxkit/Button/TextButton'
import Caption from 'components/Luxkit/Typography/Caption'
import Heading from 'components/Luxkit/Typography/Heading'
import Pill from 'components/Luxkit/Pill'
import Group from 'components/utils/Group'
import BodyText from 'components/Luxkit/Typography/BodyText'

export interface PriceRoomTypeProps {
  onView: (ref: string) => void;
  priceFrom: App.CruisePriceDetails;
  header?: boolean;
  hasValidDepartures?: boolean;
}

function CruisePriceRoomTypeInfo({ onView, priceFrom, hasValidDepartures, header = false }: PriceRoomTypeProps): JSX.Element {
  return (
    <Group direction="horizontal" verticalAlign="center" horizontalAlign="space-between" tabletGap={16}>
      {hasValidDepartures && <>
        <Group direction="vertical" gap={4}>
          <Group direction="horizontal" gap={4}>
            <Caption variant="large" colour="neutral-two">from </Caption>
            <Heading variant="heading6">
              <FormatCurrency value={priceFrom.total} />
            </Heading>
            <Caption variant="large" colour="neutral-two">/person</Caption>
          </Group>
          <Caption variant="large" colour="neutral-three">Twin share </Caption>

          {!header && priceFrom.discountPills?.discountPercentage && (
            <Pill
              kind="primary"
              variant="success"
            >
              Save up to {priceFrom.discountPills.discountPercentage}%
            </Pill>
          )}
        </Group>

        <TextButton kind="primary" onClick={() => onView(CruiseContentSections.DEPARTURES)}>
          Check Availability
        </TextButton>
      </>}

      {!hasValidDepartures && <Group direction="vertical" verticalAlign="center" fullWidth>
        <BodyText variant="large" weight="bold" align="center">
          This offer has sold out
        </BodyText>
      </Group>}

    </Group>
  )
}

export default CruisePriceRoomTypeInfo
